import { PayloadAction } from '@reduxjs/toolkit'
import { getBankingProductLoanReceipts } from '@repo/accounts-services'
import { LoanItem, MovementFilters } from '@repo/accounts-types'
import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { put, select } from 'redux-saga/effects'
import { accountsBankingProductLoanReceiptsFiltersSelector } from '../../../../selectors'
import {
  bankingProductLoanReceiptsDataActions,
  bankingProductLoanReceiptsDownloadActions,
} from '../../../../slices'

export const bankingProductLoanReceiptsDownloadConfig: Record<
  string,
  DownloadServiceConfiguration
> = {
  [bankingProductLoanReceiptsDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductLoanReceipts as DownloadServiceConfiguration['service'],
    actionTypeRequest: bankingProductLoanReceiptsDownloadActions.downloadRequest.type,
    actionTypeResponse: bankingProductLoanReceiptsDownloadActions.downloadResponse.type,
  },
}

export const serviceConfig = defineSagaForService({
  [bankingProductLoanReceiptsDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductLoanReceipts,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: bankingProductLoanReceiptsDataActions.getResponse.type,
    actionTypeRequest: bankingProductLoanReceiptsDataActions.getRequest.type,
  },
})

export function* loadBankingProductLoanReceiptsByFilters({
  payload,
}: PayloadAction<{ id: LoanItem['id'] }>) {
  const { id } = payload
  const filters: MovementFilters = yield select(
    accountsBankingProductLoanReceiptsFiltersSelector(id),
  ) || null
  yield put(bankingProductLoanReceiptsDataActions.getRequest({ id, ...filters }))
}
